import z from "zod";
import { ComboMultipliersConfigDbSchema, FlexComboMultipliersConfigDbSchema } from "./db-schemas";
import { range } from "remeda";

export function calculatePowerplayComboMultiplier({
	combo_multipliers_config,
	combo_picks_count,
}: {
	combo_multipliers_config: z.infer<typeof ComboMultipliersConfigDbSchema>;
	combo_picks_count: number;
}) {
	const offset = combo_multipliers_config.offset;
	const multipliers = combo_multipliers_config.multipliers;
	const dummy_filler = range(0, offset - 1).map(n => null)
	const mult = [ ...dummy_filler, ...multipliers ].at(combo_picks_count - 1);

	if(mult === undefined || mult === null) {
		throw new Error(`Invalid combo picks count: ${combo_picks_count}`);
	}

	return mult;
}

export function calculateFlexplayComboMultiplier({
	flex_combo_multipliers_config,
	combo_picks_count,
	lost_picks_count,
}: {
	flex_combo_multipliers_config: z.infer<typeof FlexComboMultipliersConfigDbSchema>;
	combo_picks_count: number;
	lost_picks_count: number;
}) {
	const picks_count_index = combo_picks_count - flex_combo_multipliers_config.offset;
	const picks_count_row = flex_combo_multipliers_config.multipliers_by_lost_picks.at(picks_count_index);
	const multiplier = picks_count_row?.at(lost_picks_count);

	if(multiplier === undefined) {
		throw new Error(`Invalid flex combo params: picks=${combo_picks_count}, lost=${lost_picks_count}`);
	}

	return multiplier;
}
